export default {"src":"/_next/static/media/youth-audience.327dec89.svg","height":75,"width":76,"blurWidth":0,"blurHeight":0};